import { render } from "./VenueManagement.vue?vue&type=template&id=0015a2ee&scoped=true"
import script from "./VenueManagement.vue?vue&type=script&lang=js"
export * from "./VenueManagement.vue?vue&type=script&lang=js"

import "./VenueManagement.vue?vue&type=style&index=0&id=0015a2ee&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0015a2ee"]])

export default __exports__